/**
 * Discriminates a Service Request attempt from a Bundle Request attempt
 * across the shared proposal-review / signed-contract / PO / documents flows
 * (TDF-1342 Phase 3). The review-proposal, sign-contract, and upload-PO
 * screens are identical between the two per design — only the endpoint and
 * the id field name sent to it differ, so one set of pages/hooks/stores
 * serves both, switched on this value.
 *
 * Carried as a `serviceType` query param on the shared routes
 * (`?serviceType=bundle`) — always sent by the code that builds the link
 * (BundleDetailPage/ServiceDetailPage), never relied on from an external
 * source. Absent means `'service'`, for backward compatibility with any
 * direct/bookmarked link that predates this param.
 */
export type AttemptServiceType = 'service' | 'bundle';

export const DEFAULT_ATTEMPT_SERVICE_TYPE: AttemptServiceType = 'service';

/** Parses a raw query-param value, defaulting to 'service' for anything else. */
export const toAttemptServiceType = (
  value: string | null | undefined
): AttemptServiceType => (value === 'bundle' ? 'bundle' : 'service');
